(function () {
    'use strict';
    angular.module('wamasysApp').controller('NotificationsController', NotificationsController)
        .controller('NotificationDetailController', NotificationDetailController);
    NotificationsController.$inject = ['$scope', 'NotificationInbox'];
    function NotificationsController($scope, inbox) {
        var vm = this, generation = inbox.generation(), destroyed = false, refreshPending = false;
        vm.messages = []; vm.loading = false; vm.push = inbox.push;
        vm.load = load; vm.more = function () { load(vm.nextBeforeId); };
        vm.enablePush = function () { inbox.enablePush().catch(angular.noop); };
        vm.disablePush = function () { inbox.disablePush().catch(angular.noop); };
        function load(beforeId) {
            if (vm.loading) { return; }
            vm.loading = true; vm.error = null; generation = inbox.generation();
            inbox.page(beforeId).then(function (result) {
                if (destroyed || generation !== inbox.generation()) { return; }
                vm.messages = beforeId ? vm.messages.concat(result.messages) : result.messages;
                vm.nextBeforeId = result.nextBeforeId;
            }).catch(function (error) {
                if (!destroyed && !error.cancelled) { vm.error = 'Impossible de charger les messages. Réessayez.'; }
            }).finally(function () {
                vm.loading = false;
                if (!destroyed && refreshPending) { refreshPending = false; load(); }
            });
        }
        $scope.$on('notifications:changed', function () {
            if (vm.messages.length) { vm.notice = 'La boîte a été actualisée avec les messages les plus récents.'; }
            if (vm.loading) { refreshPending = true; } else { load(); }
        });
        $scope.$on('notifications:reset', function () { vm.messages = []; vm.nextBeforeId = null; vm.notice = null; refreshPending = false; });
        $scope.$on('$destroy', function () { destroyed = true; });
        load();
    }
    NotificationDetailController.$inject = ['$scope', '$stateParams', '$timeout', '$window', 'NotificationInbox'];
    function NotificationDetailController($scope, $stateParams, $timeout, $window, inbox) {
        var vm = this, destroyed = false, sending = false, generation = inbox.generation(), timer;
        vm.load = load; vm.retryRead = acknowledge;
        function acknowledge() {
            // Une cloche, un toast ou un onglet masqué ne constituent pas une lecture.
            if (destroyed || generation !== inbox.generation() || !vm.message || vm.message.read || sending
                    || $window.document.hidden || !$window.document.hasFocus()) { return; }
            sending = true; vm.receiptError = null;
            inbox.read(vm.message).catch(function (error) {
                if (!destroyed && !error.cancelled) { vm.receiptError = 'Lecture enregistrée à l’écran, confirmation serveur à réessayer.'; }
            }).finally(function () { sending = false; });
        }
        function focused() { $scope.$evalAsync(acknowledge); }
        function load() {
            vm.loading = true; vm.error = null; generation = inbox.generation();
            inbox.find($stateParams.id).then(function (message) {
                if (destroyed || generation !== inbox.generation()) { return; }
                vm.message = message;
                // Attendre que le détail soit rendu avant d'envoyer READ.
                timer = $timeout(acknowledge, 0);
            }).catch(function (error) {
                if (!destroyed && !error.cancelled) { vm.error = error.status === 404 ? 'Message introuvable.' : 'Impossible de charger ce message. Réessayez.'; }
            }).finally(function () { vm.loading = false; });
        }
        $window.addEventListener('focus', focused);
        $window.document.addEventListener('visibilitychange', focused);
        $scope.$on('notifications:changed', function () { if (!vm.message && !vm.loading) { load(); } });
        $scope.$on('notifications:reset', function () { vm.message = null; vm.receiptError = null; });
        $scope.$on('$destroy', function () {
            destroyed = true; $timeout.cancel(timer);
            $window.removeEventListener('focus', focused); $window.document.removeEventListener('visibilitychange', focused);
        });
        load();
    }
}());
